module.exports = __webpack_public_path__ + "img/momo_title_redeem.b80e115c.png";